import { IIsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";

export interface IIsiDtoPlAttPreviewResponse extends IIsiDtoPresentationLogicResponse  {
    getRightDeleteResult?: IIsiDtoPlAttPreviewResult;
    getRightAddResult?: IIsiDtoPlAttPreviewResult;
}
export interface IIsiDtoPlAttPreviewResult extends IIsiDataTransferObject  {
    attPreviewBoolResult?: boolean;
    attPreviewResult?: string;
}
export class IsiDtoPlAttPreviewResult extends IsiDataTransferObject implements IIsiDtoPlAttPreviewResult {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.AttPreview.IsiDtoPlAttPreviewResult, Isilog.IsiComponent.IsiDataTransferObject";
    attPreviewBoolResult?: boolean;
    attPreviewResult?: string;

    constructor(data?: IIsiDtoPlAttPreviewResult) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.attPreviewBoolResult = _data["attPreviewBoolResult"] !== undefined ? _data["attPreviewBoolResult"] : false;
            this.attPreviewResult = _data["attPreviewResult"] !== undefined ? _data["attPreviewResult"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlAttPreviewResult): IsiDtoPlAttPreviewResult {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlAttPreviewResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["attPreviewBoolResult"] = this.attPreviewBoolResult !== undefined ? this.attPreviewBoolResult : false;
        data["attPreviewResult"] = this.attPreviewResult !== undefined ? this.attPreviewResult : <any>null;
        return data;
    }
}
export class IsiDtoPlAttPreviewResponse extends IsiDtoPresentationLogicResponse implements IIsiDtoPlAttPreviewResponse {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.AttPreview.IsiDtoPlAttPreviewResponse, Isilog.IsiComponent.IsiDataTransferObject";
    getRightDeleteResult?: IsiDtoPlAttPreviewResult;
    getRightAddResult?: IsiDtoPlAttPreviewResult;

    constructor(data?: IIsiDtoPlAttPreviewResponse) {
        super(data);
        if (data) {
            this.getRightDeleteResult = data.getRightDeleteResult && !(<any>data.getRightDeleteResult).toJSON ? new IsiDtoPlAttPreviewResult(data.getRightDeleteResult) : <IsiDtoPlAttPreviewResult>this.getRightDeleteResult;
            this.getRightAddResult = data.getRightAddResult && !(<any>data.getRightAddResult).toJSON ? new IsiDtoPlAttPreviewResult(data.getRightAddResult) : <IsiDtoPlAttPreviewResult>this.getRightAddResult;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.getRightDeleteResult = _data["getRightDeleteResult"] ? IsiDtoPlAttPreviewResult.fromJS(_data["getRightDeleteResult"]) : <any>null;
            this.getRightAddResult = _data["getRightAddResult"] ? IsiDtoPlAttPreviewResult.fromJS(_data["getRightAddResult"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlAttPreviewResponse): IsiDtoPlAttPreviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlAttPreviewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["getRightDeleteResult"] = this.getRightDeleteResult != null ? (<any>this.getRightDeleteResult).toJSON() : <any>null;
        data["getRightAddResult"] = this.getRightAddResult != null ? (<any>this.getRightAddResult).toJSON() : <any>null;
        return data;
    }
}
export interface IIsiDtoPlAttPreviewRequest extends IIsiDtoPresentationLogicRequest  {
    response?: IIsiDtoPlAttPreviewResponse;
    codeMemo?: number;
    codeDocole?: number;
}
export class IsiDtoPlAttPreviewRequest extends IsiDtoPresentationLogicRequest implements IIsiDtoPlAttPreviewRequest {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.AttPreview.IsiDtoPlAttPreviewRequest, Isilog.IsiComponent.IsiDataTransferObject";
    response?: IsiDtoPlAttPreviewResponse;
    codeMemo?: number;
    codeDocole?: number;

    constructor(data?: IIsiDtoPlAttPreviewRequest) {
        super(data);
        if (data) {
            this.response = data.response && !(<any>data.response).toJSON ? new IsiDtoPlAttPreviewResponse(data.response) : <IsiDtoPlAttPreviewResponse>this.response;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.response = _data["response"] ? IsiDtoPlAttPreviewResponse.fromJS(_data["response"]) : <any>null;
            this.codeMemo = _data["codeMemo"] !== undefined ? _data["codeMemo"] : null;
            this.codeDocole = _data["codeDocole"] !== undefined ? _data["codeDocole"] : null;
        }
    }

    static fromJS(data?: IIsiDtoPlAttPreviewRequest): IsiDtoPlAttPreviewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlAttPreviewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["response"] = this.response != null ? (<any>this.response).toJSON() : <any>null;
        data["codeMemo"] = this.codeMemo !== undefined ? this.codeMemo : null;
        data["codeDocole"] = this.codeDocole !== undefined ? this.codeDocole : null;
        return data;
    }
}
